'use client';

import {
  Dispatch,
  ReactNode,
  RefObject,
  SetStateAction,
  createContext,
  useContext,
  useMemo,
  useRef,
  useState,
} from 'react';

import { WidgetInstance } from 'friendly-challenge';

type Context = {
  solution: string;
  setSolution: Dispatch<SetStateAction<string>>;
  container: RefObject<HTMLDivElement | null>;
  widgetRef: RefObject<WidgetInstance | null>;
};

const RecaptchasContext = createContext<Context | null>(null);

interface Props {
  children: ReactNode;
}

const RecaptchasProvider = ({ children }: Props) => {
  const [solution, setSolution] = useState('');
  const container = useRef<HTMLDivElement | null>(null);
  const widgetRef = useRef<WidgetInstance | null>(null);

  const value = useMemo(
    () => ({ solution, setSolution, container, widgetRef }),
    [solution]
  );

  return (
    <RecaptchasContext.Provider value={value}>
      {children}
    </RecaptchasContext.Provider>
  );
};

function useRecaptchas() {
  const context = useContext(RecaptchasContext);
  if (!context) throw new Error('useRecaptchas requires a context!');

  return context;
}

export { RecaptchasProvider, useRecaptchas };
